var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { UI_THEME_PRESETS, formatInvalidValue, formatExpectedValues, propEnumsForType, } from '../sceneCatalog';
import { looksLikeColorOrImage, valueKind } from './colorHelpers';
export function issue(path, message, code, expected) {
    var out = { path: path, message: message };
    if (code)
        out.code = code;
    if (expected && expected.length)
        out.expected = expected;
    return out;
}
export function toErrorLines(issues) {
    return issues.map(function (i) { return "".concat(i.path, ": ").concat(i.message); });
}
export function validatePropEnums(type, props, path, issues) {
    var e_1, _a;
    var enums = propEnumsForType(type);
    try {
        for (var _b = __values(Object.entries(enums)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], allowed = _d[1];
            if (!(key in props))
                continue;
            var got = props[key];
            if (got === undefined || got === null)
                continue;
            if (typeof got !== 'string') {
                issues.push(issue("".concat(path, ".props.").concat(key), "must be a string (".concat(formatExpectedValues(allowed), "), got ").concat(valueKind(got)), 'prop_type', __spreadArray([], __read(allowed), false)));
                continue;
            }
            if (!allowed.includes(got)) {
                issues.push(issue("".concat(path, ".props.").concat(key), formatInvalidValue(got, allowed), 'prop_enum', __spreadArray([], __read(allowed), false)));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (typeof props.uiTheme === 'string' && props.uiTheme && !looksLikeColorOrImage(props.uiTheme)) {
        if (!UI_THEME_PRESETS.includes(props.uiTheme)) {
            issues.push(issue("".concat(path, ".props.uiTheme"), formatInvalidValue(props.uiTheme, UI_THEME_PRESETS) +
                ' — or a CSS color / image path / token object', 'uiTheme_preset', __spreadArray([], __read(UI_THEME_PRESETS), false)));
        }
    }
}
